import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createStrategicAxis(
    request: Boundaries["createStrategicAxis"]["request"],
  ): void;
}

function useCreateStrategicAxis(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isCreateStrategicAxisRequestPending),
    isRequestSuccess: useSelector(selector.isCreateStrategicAxisRequestSuccess),
    isRequestFailure: useSelector(selector.isCreateStrategicAxisRequestFailure),
    createStrategicAxis: core.createStrategicAxis,
  };
}

export { useCreateStrategicAxis };
